module.exports = __webpack_public_path__ + "img/Instagram.2e5debad.png";